<template>
  <div class="mask" v-if="dataVal.flag">
    <div class="mask-content">
      <div class="mask-content-header">
        <div>邀请人数</div>
        <div @click="handleRefund">
          <el-icon name="close" size="16"></el-icon>
        </div>
      </div>
      <div class="mask-content-body">
        <div class="pc-table pc-table-color">
          <el-table :data="list" ref="multipleTableW" height="62vh" style="width: 100%" border>
            <!-- 序号 -->
            <el-table-column type="index" label="序号" align="center" width="62"></el-table-column>
            <el-table-column prop="name" label="姓名" align="center" width="100">
              <template slot-scope="scope">
                <div style="color: #c12e30">
                  {{ scope.row.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号" align="center" width="120">
            </el-table-column>
            <el-table-column prop="role" label="行业身份" align="center" width="120">
            </el-table-column>
            <el-table-column prop="danwei" label="公司名称" align="center" width="100">
            </el-table-column>
            <el-table-column prop="brand" label="品牌名称" align="center" width="150">
            </el-table-column>
            <el-table-column prop="createtime" label="报名时间" align="center" width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.createtime">
                  {{
                    (scope.row.createtime * 1000)
                    | formatTimestamp("yyyy-MM-dd")
                  }}
                </div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column prop="inviter" label="邀请人" align="center" width="100">
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <div class="pagination-total">共{{ total_count }}条</div>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="fromData.page" :page-sizes="[10, 20, 50, 100, 200, 500, total_count]"
            :page-size="fromData.count" layout="sizes, prev, pager, next, jumper" :total="total_count" background>
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddGroup",
  props: ["dataVal"],
  data() {
    return {
      multipleSelection: [],
      //表格列表
      list: [
        {
          times: 1757988244,
          status: 1,
          name: "张三",
        },
      ],
      total_count: 0,
      fromData: {
        user_id: "",
        activity_id: "",
        page: 1,
        count: 10,
      },
    };
  },
  mounted() { },
  methods: {
    //分页事件 点击每页多少条
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.fromData.count = val;
      this.activityInvitelog();
    },
    //分页事件 点击页数
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.fromData.page = val;
      this.activityInvitelog();
    },
    //邀请人列表
    async activityInvitelog() {
      let res = await this.$api.activityInvitelog({
        ...this.fromData,
      });
      if (res.code == 1) {
        this.list = res.data.list;
        this.total_count = res.data.total_count;
      }
    },
    //取消弹窗
    handleRefund() {
      let data = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("invitationListCall", data);
    },
  },
  watch: {
    dataVal: {
      handler(val) {
        if (val.flag) {
          this.fromData.user_id = val.user_id;
          this.fromData.activity_id = val.activity_id;
          this.activityInvitelog();
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.mask {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .mask-content {
    width: 885px;
    border-radius: 10px;
    background: #fff;
    overflow: hidden;
    position: fixed;

    .mask-content-header {
      width: 100%;
      min-height: 50px;
      background: #c12e30;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 20px;

      div {
        color: var(--Gray-White, #fff);
        font-size: 16px;
      }

      .el-icon-close {
        color: #fff;
      }
    }

    .mask-content-body {
      width: 100%;
      background-color: #fff;
      padding: 15px;

      .mask-content-body-select {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .mask-content-body-select-title {
          width: 87px;
          color: #a6a6a6;
          font-size: 14px;
          display: flex;
          align-items: center;

          span {
            color: #c12e30;
          }
        }

        .mask-content-body-select-input {
          flex: 1;

          .el-select {
            width: 100%;
          }
        }
      }

      .mask-content-footer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 6px;

        div {
          width: 120px;
          height: 40px;
          color: rgba(0, 0, 0, 0.9);
          font-size: 14px;
          border-radius: 5px 0 0 5px;
          background: #edc2c3;
          @include flex-center(center, center);
          cursor: pointer;

          &:nth-child(2) {
            border-radius: 0 5px 5px 0;
            color: rgba(255, 255, 255, 0.9);
            background: #b30003;
          }
        }
      }
    }
  }
}
</style>